export default __webpack_public_path__ + "static/media/cross.099f6c04.svg";